import { CreatorBrand } from 'constants/brands';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Modal, Button, Text, Group } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { useCreatorContext } from 'controllers/business/Creator/Creator.controller';

const StyledGroupItem = styled(Group.Item)`
    width: 100%;
`;

const StyledGroup = styled(Group)`
    width: 50%;
    ${({ theme }): string => theme.breakpoint('md')`
        width: 100%; 
    `}
`;

export const ConfirmLoadSessionModal: React.FC = () => {
    const {
        state: creatorState,
        closeLoadSessionModal,
        dispatchLoadSession,
        openCreator,
    } = useCreatorContext();

    const handleOnClick = useCallback(() => {
        dispatchLoadSession();
        openCreator();
    }, [dispatchLoadSession, openCreator]);

    return (
        <Modal
            isOpen={creatorState.isLoadSessionModalOpen}
            onClose={closeLoadSessionModal}
        >
            <Modal.Content>
                <Modal.Section>
                    <Group direction="vertical" gutter="xs">
                        <Group.Item>
                            <Text size="xl" fontWeight="bold">
                                <Trans>Open in {CreatorBrand}?</Trans>
                            </Text>
                        </Group.Item>
                        <Group.Item>
                            <Text size="md" contrast={'low'}>
                                <Trans>
                                    You’re about to add samples to{' '}
                                    {CreatorBrand}. All sounds currently in{' '}
                                    {CreatorBrand} will be removed. Are you
                                    sure?
                                </Trans>
                            </Text>
                        </Group.Item>
                    </Group>
                    <StyledGroup
                        mt="xl"
                        ml="auto"
                        justifyContent="right"
                        alignItems="center"
                    >
                        <StyledGroupItem>
                            <Button
                                kind="minimal"
                                variant="secondary"
                                onClick={closeLoadSessionModal}
                                isFull
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        </StyledGroupItem>
                        <StyledGroupItem ml="md">
                            <Button
                                variant="primary"
                                onClick={handleOnClick}
                                isFull
                            >
                                <Trans>Continue</Trans>
                            </Button>
                        </StyledGroupItem>
                    </StyledGroup>
                </Modal.Section>
            </Modal.Content>
        </Modal>
    );
};

export default ConfirmLoadSessionModal;
